"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_boost_1 = require("apollo-boost");
const react_csv_1 = require("react-csv");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const params_1 = require("use-query-params/lib/params");
const use_query_params_1 = require("use-query-params");
const moment_1 = __importDefault(require("moment"));
function DownloadingAssertView(props) {
    const queryParamsConfig = {
        onlyShowDiff: params_1.BooleanParam,
    };
    const [query] = use_query_params_1.useQueryParams(queryParamsConfig);
    const { onlyShowDiff = false, } = query;
    const GET_INVENTORY_INFOS = apollo_boost_1.gql `
    query getAssertionInventoryInfo($assertionInfoId: String!, $onlyShowDiff: Boolean!) {
      getAssertionInventoryItems(assertionInfoId: $assertionInfoId, offset: 0, limit: 0, onlyShowDiff: $onlyShowDiff){
        id
        stockInfo {
          _id
          stock {
            product {
              key
              name
              salePrice
              brand {
                name
              }
            }
          }
        }
        qty
        projectedQty
        averageCost
      }
      getAssertionInfo(id: $assertionInfoId) {
        id
        sn
        warehouse {
          name
        }
        assertedCost
        projectedCost
      }
    }
  `;
    const { loading: isLoading, error, data } = react_hooks_1.useQuery(GET_INVENTORY_INFOS, {
        variables: {
            assertionInfoId: props.id,
            onlyShowDiff,
        },
    });
    if (error)
        return react_1.default.createElement(react_1.default.Fragment, null, "error");
    if (isLoading || data === undefined)
        return react_1.default.createElement(react_1.default.Fragment, null, "\u6B63\u5728\u6E96\u5099\u8981\u4E0B\u8F09\u7684\u8CC7\u6599");
    const header = [
        '商品編號',
        '商品名稱',
        '已點數量',
        '庫存數量',
        '盤差',
    ];
    if (props.canDisplayCost) {
        header.push('平均成本');
    }
    header.push('售價', '品牌');
    if (props.canDisplayCost) {
        header.push('', '已盤金額', '盤差金額', '應盤金額');
    }
    const output = [header];
    if (props.canDisplayCost) {
        output.push([
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            data.getAssertionInfo.assertedCost.toString(),
            (data.getAssertionInfo.projectedCost - data.getAssertionInfo.assertedCost).toString(),
            data.getAssertionInfo.projectedCost.toString(),
        ]);
    }
    data.getAssertionInventoryItems.forEach((e) => {
        e.diff = (e.qty - e.projectedQty);
        const stockInfo = e.stockInfo;
        let stock;
        if (stockInfo == null) {
            stock = {
                product: {
                    key: '(N/A)',
                    name: '(N/A)',
                    brand: {
                        name: '(N/A)',
                    },
                },
            };
        }
        else {
            stock = stockInfo.stock;
            if (stock.product.brand == null) {
                stock.product.brand = { name: '(N/A)' };
            }
        }
        const row = [
            stock.product.key,
            stock.product.name,
            e.qty,
            e.projectedQty,
            e.diff,
        ];
        if (props.canDisplayCost) {
            row.push(e.averageCost);
        }
        row.push(stock.product.salePrice, stock.product.brand.name);
        output.push(row);
    });
    let filename = `盤點列表-${data.getAssertionInfo.warehouse.name}`;
    if (onlyShowDiff) {
        filename += '-有盤差的';
    }
    else {
        filename += '-盤點總表';
    }
    filename += `-${moment_1.default().format('YYYYMMDDHHmm')}-${data.getAssertionInfo.sn}.csv`;
    return (react_1.default.createElement(react_csv_1.CSVLink, { data: output, filename: filename }, "\u4E0B\u8F09\u76E4\u9EDE\u5217\u8868 (csv)"));
}
function AssertInfoDownloaderView(props) {
    const [isPreparing, setToPrepare] = react_1.useState(false);
    const actions = [
        {
            text: '下載',
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                setToPrepare(true);
            }),
            props: {
                variant: 'outlined',
            },
        },
    ];
    const view = (() => {
        if (!isPreparing) {
            return (react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }));
        }
        return react_1.default.createElement(DownloadingAssertView, { id: props.id, canDisplayCost: props.canDisplayCost });
    })();
    return (react_1.default.createElement("div", { style: {
            margin: '0px 30px',
            display: 'inline-block',
        } }, view));
}
exports.default = AssertInfoDownloaderView;
